(function() {

  const buildBundleUdf1AllocatedPrices = (parentPriceCents, selectionPrices) => {
    if (window.jafraBuildBundleUdf1AllocatedPrices) {
      return window.jafraBuildBundleUdf1AllocatedPrices(parentPriceCents, selectionPrices);
    }
    return String(selectionPrices || "")
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean)
      .map((priceCents) => (Number(priceCents) / 100).toFixed(2))
      .join("<>");
  };

  const resolveParentVariantPriceCents = (variantId, quantity = 1) => {
    const productJsonEl = document.querySelector("[data-product-json]");
    if (!productJsonEl) return 0;
    const productJson = JSON.parse(productJsonEl.textContent);
    const variant = productJson.variants.find(
      (variantItem) => String(variantItem.id) === String(variantId),
    );
    const normalizedQuantity = Math.max(Number(quantity) || 1, 1);
    return variant?.price ? variant.price * normalizedQuantity : 0;
  };
  
  const wrapper =  document.querySelector('product-form');
  const options = wrapper.querySelectorAll('[name^="options"]');
  const popoutOptions = wrapper.querySelectorAll('[data-popout-option]');
  const qtySelect = wrapper.querySelector('[data-quantity-input]');
  const addToCartBtn = wrapper.querySelector('[data-bundle-custom-v3-add-to-cart]');
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  
  const selectables = wrapper.querySelectorAll('[data-bundle-selectable]');
  const selectablesArr = Array.from(selectables);

  const bundleJson = JSON.parse(document.querySelector('[data-bundle-custom-v3-json]').innerHTML);
  const bundleNonSelectablesJson = bundleJson.non_selectables;
  const bundleSelectablesJson = bundleJson.selectables_merged;
  const bundleLimitSelectables = bundleJson.limit_selectables;

  init();

  function init() {
    addToCartBtn.addEventListener('click', handleAddToCart);
    options.forEach((opt) => {
      opt.addEventListener('change', handleOptionChange);
    });
  }

  function handleOptionChange(evt) {
    var targetSelectable = evt.target.closest('[data-bundle-selectable]');
    var selectedOptionId = parseFloat(evt.target.value);
    var selectedOption = bundleSelectablesJson.find((item) => item.id === selectedOptionId);
  
    if (targetSelectable && selectedOption) {
      targetSelectable.dataset.bundleSelectedOptionId = selectedOptionId;
      targetSelectable.dataset.bundleSelectedOption = selectedOption.title;
      
      updateIncludesProduct(targetSelectable.dataset.bundleItemIndex, selectedOptionId);
      configureOptions(targetSelectable);
      configureAddButton();
    }
  }

  function handleAddToCart() {
    const idElem = wrapper.querySelector('[name^="id"]');
    const setElem = wrapper.querySelector('[data-bundle-custom-parent]');
    if (!idElem.value) return;
    
    var id = idElem.value;
    var multiplier = qtySelect ? parseFloat(qtySelect.value) : 1;
    var bundleSelectedOptions = selectablesArr.map((elem) => {
      if (!elem.dataset.bundleSelectedOptionId) return null;
      return bundleSelectablesJson.find((item) => item.id === parseFloat(elem.dataset.bundleSelectedOptionId));
    }).filter(x => x);
    var bundleNonSelectables = bundleNonSelectablesJson;
    var bundleItems = [bundleNonSelectables, bundleSelectedOptions].flat();
    var commissionable = setElem.getAttribute('data-bundle-custom-parent-commissionable');

    const formData = {
      items: []
    };

    const selectionPrices = bundleItems.map((item) => item.price).join(", ");
    const item = {
      id,
      quantity: multiplier,
      properties: {
        _commissionable: commissionable,
        _bundle_selection: bundleItems.map((item) => item.title).join(" <> "),
        _bundle_selection_ids: bundleItems.map((item) => item.id).join(", "),
        _bundle_selection_prices: selectionPrices,
        _UDF1: buildBundleUdf1AllocatedPrices(
          resolveParentVariantPriceCents(id, multiplier),
          selectionPrices,
        ),
      }
    };

    for (let i = 0; i < bundleNonSelectables.length; i++) {
      item.properties[`Product ${i + 1}`] = bundleNonSelectables[i].title;
    };
    for (let i = 0; i < bundleSelectedOptions.length; i++) {
      item.properties[`Selection ${i + 1}`] = bundleSelectedOptions[i].title;
    };

    formData.items.push(item);

    addToCartAction(formData, addToCartBtn);
  }

  function updateIncludesProduct(index, variant_id) {
    const targetIncludesProduct = document.querySelector(`[data-includes-bundle-item-group-index="${index}"]`);

    if (!targetIncludesProduct) return;
    
    const targetIncludesTitle = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-title]');
    const targetIncludesContent = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-content]');
    const targetIncludesMedia = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-media]');

    if (targetIncludesTitle) {
      renderProductTitle(targetIncludesTitle, variant_id);
    }
    if (targetIncludesContent) {
      renderProductContent(targetIncludesContent, variant_id);
    }
    if (targetIncludesMedia) {
      renderProductMedia(targetIncludesMedia, variant_id);
    }
  }

  function configureOptions(target) {
    if (!bundleLimitSelectables) return;
    
    var bundleSelectedOptionIds = selectablesArr.map((elem) => parseFloat(elem.dataset.bundleSelectedOptionId)).filter(x => x);

    popoutOptions.forEach((popoutOpt) => {
      const parentSelectable = popoutOpt.closest('[data-bundle-selectable]');
      const parentSelectableOptionId = parentSelectable.dataset.bundleSelectedOptionId ? parseFloat(parentSelectable.dataset.bundleSelectedOptionId) : null;
      const popoutOptionValue = popoutOpt.dataset.value ? parseFloat(popoutOpt.dataset.value) : null;

      if (parentSelectable === target) return;

      if (bundleSelectedOptionIds.includes(popoutOptionValue) && parentSelectableOptionId !== popoutOptionValue) {
        popoutOpt.classList.add('disabled');
      } else {
        popoutOpt.classList.remove('disabled'); 
      }
    })
  }

  function configureAddButton() {
    const allSelectionsMade = selectablesArr.every((selectable) => selectable.dataset.bundleSelectedOption !== "");

    if (allSelectionsMade) {
      addToCartBtn.removeAttribute("disabled");
    } else { 
      addToCartBtn.disabled = true; 
    }
  }
 
  /*------- Helpers -------*/

  function renderProductMedia(target_media, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-media`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_media.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function renderProductTitle(target_title, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-title`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_title.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function renderProductContent(target_content, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-content`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_content.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function addToCartAction(formData, btn) {
    if (formData.items.length) {
      btn.disabled = true;
      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then((res) => {
        if (!res.ok) throw new Error("Unable to add to cart");
        return res.json();
      })
      .then((data) => {
        reloadCart();
        btn.classList.remove('loading');
        btn.classList.add('has-success');

        setTimeout(() => {
          btn.classList.remove('has-success');
          btn.disabled = false;
          openDrawer();
        }, 1500);
      })
      .catch((err) => {
        btn.classList.remove('loading');
        console.error(err);
      })
    }
  }

  function reloadCart() {
    document.dispatchEvent(
      new CustomEvent('theme:cart:init', {
        bubbles: true
      })
    );
    document.dispatchEvent(
      new CustomEvent("theme:cart:reload", {
        bubbles: true,
      })
    );
  }

  function openDrawer() {
    cartDrawer.dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: true,
      })
    );
  }

})();